export function resetHash() {
  window.history.replaceState(null, '', ' ');
}

export function getHash(): string {
  return window.location.hash.substring(1);
}
